<script>
  export let imspezial;

  const parseTime = (t) => { const [h, m] = t.split(":").map(Number); return h * 60 + m; };
  const startMinutes = parseTime(imspezial.startTime);
  const endMinutes = parseTime(imspezial.endTime);
  const offsetMinutes = startMinutes - 8 * 60;
  const durationMinutes = endMinutes - startMinutes;

  const timeblockStyle = `position: absolute; top: ${offsetMinutes * 3}px; height: ${durationMinutes * 3}px;`;
</script>

<div class="not-prose right-[2%] w-[46%] border border-solid rounded-md border-gray-400/50 bg-im-brown-100 p-3 drop-shadow-md" style={timeblockStyle}>
  <div class="bg-im-signal border border-solid rounded-md -mx-3 px-3">
    <span class="text-sm font-bold uppercase text-white">
      IM Spezial
    </span>
  </div>
  <span class="text-xs font-bold">{imspezial.startTime} - {imspezial.endTime}</span>
</div>
